import { Message, proto3 } from '@bufbuild/protobuf';
/**
 * @generated from enum plugnmeet.SpeechServiceUserStatusTasks
 */
export var SpeechServiceUserStatusTasks;
(function (SpeechServiceUserStatusTasks) {
    /**
     * @generated from enum value: SPEECH_TO_TEXT_SESSION_STARTED = 0;
     */
    SpeechServiceUserStatusTasks[SpeechServiceUserStatusTasks["SPEECH_TO_TEXT_SESSION_STARTED"] = 0] = "SPEECH_TO_TEXT_SESSION_STARTED";
    /**
     * @generated from enum value: SPEECH_TO_TEXT_SESSION_ENDED = 1;
     */
    SpeechServiceUserStatusTasks[SpeechServiceUserStatusTasks["SPEECH_TO_TEXT_SESSION_ENDED"] = 1] = "SPEECH_TO_TEXT_SESSION_ENDED";
    /**
     * @generated from enum value: SPEECH_TO_TEXT_TOTAL_USAGE = 2;
     */
    SpeechServiceUserStatusTasks[SpeechServiceUserStatusTasks["SPEECH_TO_TEXT_TOTAL_USAGE"] = 2] = "SPEECH_TO_TEXT_TOTAL_USAGE";
})(SpeechServiceUserStatusTasks || (SpeechServiceUserStatusTasks = {}));
// Retrieve enum metadata with: proto3.getEnumType(SpeechServiceUserStatusTasks)
proto3.util.setEnumType(SpeechServiceUserStatusTasks, 'plugnmeet.SpeechServiceUserStatusTasks', [
    { no: 0, name: 'SPEECH_TO_TEXT_SESSION_STARTED' },
    { no: 1, name: 'SPEECH_TO_TEXT_SESSION_ENDED' },
    { no: 2, name: 'SPEECH_TO_TEXT_TOTAL_USAGE' },
]);
/**
 * @generated from message plugnmeet.SpeechToTextTranslationReq
 */
export class SpeechToTextTranslationReq extends Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string room_id = 1;
         */
        this.roomId = '';
        /**
         * @generated from field: bool is_enabled = 3;
         */
        this.isEnabled = false;
        /**
         * @generated from field: repeated string allowed_speech_langs = 4;
         */
        this.allowedSpeechLangs = [];
        /**
         * @generated from field: repeated string allowed_speech_users = 5;
         */
        this.allowedSpeechUsers = [];
        /**
         * @generated from field: bool is_enabled_translation = 6;
         */
        this.isEnabledTranslation = false;
        /**
         * @generated from field: repeated string allowed_trans_langs = 7;
         */
        this.allowedTransLangs = [];
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new SpeechToTextTranslationReq().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SpeechToTextTranslationReq().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SpeechToTextTranslationReq().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SpeechToTextTranslationReq, a, b);
    }
}
SpeechToTextTranslationReq.runtime = proto3;
SpeechToTextTranslationReq.typeName = 'plugnmeet.SpeechToTextTranslationReq';
SpeechToTextTranslationReq.fields = proto3.util.newFieldList(() => [
    { no: 1, name: 'room_id', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 3, name: 'is_enabled', kind: 'scalar', T: 8 /* ScalarType.BOOL */ },
    {
        no: 4,
        name: 'allowed_speech_langs',
        kind: 'scalar',
        T: 9 /* ScalarType.STRING */,
        repeated: true,
    },
    {
        no: 5,
        name: 'allowed_speech_users',
        kind: 'scalar',
        T: 9 /* ScalarType.STRING */,
        repeated: true,
    },
    {
        no: 6,
        name: 'is_enabled_translation',
        kind: 'scalar',
        T: 8 /* ScalarType.BOOL */,
    },
    {
        no: 7,
        name: 'allowed_trans_langs',
        kind: 'scalar',
        T: 9 /* ScalarType.STRING */,
        repeated: true,
    },
    {
        no: 8,
        name: 'default_subtitle_lang',
        kind: 'scalar',
        T: 9 /* ScalarType.STRING */,
        opt: true,
    },
]);
/**
 * @generated from message plugnmeet.GenerateAzureTokenReq
 */
export class GenerateAzureTokenReq extends Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string room_id = 1;
         */
        this.roomId = '';
        /**
         * @generated from field: string user_sid = 2;
         */
        this.userSid = '';
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new GenerateAzureTokenReq().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GenerateAzureTokenReq().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GenerateAzureTokenReq().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GenerateAzureTokenReq, a, b);
    }
}
GenerateAzureTokenReq.runtime = proto3;
GenerateAzureTokenReq.typeName = 'plugnmeet.GenerateAzureTokenReq';
GenerateAzureTokenReq.fields = proto3.util.newFieldList(() => [
    { no: 1, name: 'room_id', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 2, name: 'user_sid', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
]);
/**
 * @generated from message plugnmeet.GenerateAzureTokenRes
 */
export class GenerateAzureTokenRes extends Message {
    constructor(data) {
        super();
        /**
         * @generated from field: bool status = 1;
         */
        this.status = false;
        /**
         * @generated from field: string msg = 2;
         */
        this.msg = '';
        /**
         * @generated from field: bool renew = 6;
         */
        this.renew = false;
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new GenerateAzureTokenRes().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GenerateAzureTokenRes().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GenerateAzureTokenRes().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GenerateAzureTokenRes, a, b);
    }
}
GenerateAzureTokenRes.runtime = proto3;
GenerateAzureTokenRes.typeName = 'plugnmeet.GenerateAzureTokenRes';
GenerateAzureTokenRes.fields = proto3.util.newFieldList(() => [
    { no: 1, name: 'status', kind: 'scalar', T: 8 /* ScalarType.BOOL */ },
    { no: 2, name: 'msg', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    {
        no: 3,
        name: 'token',
        kind: 'scalar',
        T: 9 /* ScalarType.STRING */,
        opt: true,
    },
    {
        no: 4,
        name: 'service_region',
        kind: 'scalar',
        T: 9 /* ScalarType.STRING */,
        opt: true,
    },
    {
        no: 5,
        name: 'key_id',
        kind: 'scalar',
        T: 9 /* ScalarType.STRING */,
        opt: true,
    },
    { no: 6, name: 'renew', kind: 'scalar', T: 8 /* ScalarType.BOOL */ },
]);
/**
 * @generated from message plugnmeet.AzureTokenRenewReq
 */
export class AzureTokenRenewReq extends Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string room_id = 1;
         */
        this.roomId = '';
        /**
         * @generated from field: string user_sid = 2;
         */
        this.userSid = '';
        /**
         * @generated from field: string service_region = 3;
         */
        this.serviceRegion = '';
        /**
         * @generated from field: string key_id = 4;
         */
        this.keyId = '';
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new AzureTokenRenewReq().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AzureTokenRenewReq().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AzureTokenRenewReq().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(AzureTokenRenewReq, a, b);
    }
}
AzureTokenRenewReq.runtime = proto3;
AzureTokenRenewReq.typeName = 'plugnmeet.AzureTokenRenewReq';
AzureTokenRenewReq.fields = proto3.util.newFieldList(() => [
    { no: 1, name: 'room_id', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 2, name: 'user_sid', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    {
        no: 3,
        name: 'service_region',
        kind: 'scalar',
        T: 9 /* ScalarType.STRING */,
    },
    { no: 4, name: 'key_id', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
]);
/**
 * @generated from message plugnmeet.SpeechServiceUserStatusReq
 */
export class SpeechServiceUserStatusReq extends Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string room_id = 1;
         */
        this.roomId = '';
        /**
         * @generated from field: string room_sid = 2;
         */
        this.roomSid = '';
        /**
         * @generated from field: string user_id = 3;
         */
        this.userId = '';
        /**
         * @generated from field: string key_id = 4;
         */
        this.keyId = '';
        /**
         * @generated from field: plugnmeet.SpeechServiceUserStatusTasks task = 5;
         */
        this.task = SpeechServiceUserStatusTasks.SPEECH_TO_TEXT_SESSION_STARTED;
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new SpeechServiceUserStatusReq().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SpeechServiceUserStatusReq().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SpeechServiceUserStatusReq().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SpeechServiceUserStatusReq, a, b);
    }
}
SpeechServiceUserStatusReq.runtime = proto3;
SpeechServiceUserStatusReq.typeName = 'plugnmeet.SpeechServiceUserStatusReq';
SpeechServiceUserStatusReq.fields = proto3.util.newFieldList(() => [
    { no: 1, name: 'room_id', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 2, name: 'room_sid', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 3, name: 'user_id', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 4, name: 'key_id', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    {
        no: 5,
        name: 'task',
        kind: 'enum',
        T: proto3.getEnumType(SpeechServiceUserStatusTasks),
    },
]);
